import {Component, Input, OnInit} from '@angular/core';
import {SafeUrlPipe} from "../pipes/safe-url.pipe";
import {DynamicDialogConfig, DynamicDialogRef} from "primeng/dynamicdialog";
import {NgIf} from "@angular/common";

@Component({
  selector: 'app-iframe-dialog',
  standalone: true,
    imports: [
        SafeUrlPipe,
        NgIf
    ],
  templateUrl: './iframe-dialog.component.html',
  styleUrl: './iframe-dialog.component.scss'
})
export class IframeDialogComponent implements OnInit {
    @Input() url!: string;

    constructor(
        public ref: DynamicDialogRef,
        //public config: DynamicDialogConfig
    ) {}

    ngOnInit() {
        // if (!this.url && this.config?.data?.url) {
        //     this.url = this.config.data.url;
        // }
    }
}

